// Bounds on what counts as a menstrual cycle. Used both to validate
// the cycle length a user enters and to tell cycles apart from
// breaks in tracking when predicting.
export const CYCLE_LENGTH_MIN_MAX = {
  min: 14,
  max: 70,
}

export const DEFAULT_CYCLE_LENGTH = 28
